import { render, staticRenderFns } from "./registra_conexion_usuario.vue?vue&type=template&id=051e9c70&"
import script from "./registra_conexion_usuario.vue?vue&type=script&lang=js&"
export * from "./registra_conexion_usuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports